import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeader } from "../../common/apis/authHeader";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import HandleError from "../../common/apis/HandleError";
import { toast } from 'react-toastify';
import { apiVersion } from "../../common/apis/apiVersion";

// ✅ Wallet View
export const WalletAsyncCall = createAsyncThunk(
  "wallet/WalletAsyncCall",
  async () => {
    try {
      const response = await axiosBaseURL.get("/app/" + apiVersion.v1 + "/users/wallet_view", {
        headers: authHeader()
      });
      return response.data;
    } catch (error) {
      HandleError(error.response.data);
      return error.response.data;
    }
  }
);

// ✅ Transaction History
export const TransactionHistoryAsyncCall = createAsyncThunk(
  "wallet/TransactionHistoryAsyncCall",
  async () => {
    try {
      const response = await axiosBaseURL.get("/app/" + apiVersion.v1 + "/users/view", {
        headers: authHeader()
      });
      return response.data;
    } catch (error) {
      HandleError(error.response.data);
      return error.response.data;
    }
  }
);

// ✅ Aadhaar DigiLocker Verification
export const SureVerifyAction = createAsyncThunk(
  'wallet/SureVerifyAction',
  async (formData) => {
    try {
      const response = await axiosBaseURL.post(
        "/app/" + apiVersion.v1 + "/users/sure_verify",
        formData,
        {
          headers: {
            ...authHeader(),
            "Content-Type": "multipart/form-data"
          }
        }
      );
      return response.data;
    } catch (error) {
      HandleError(error.response?.data);
      return error.response?.data;
    }
  }
);





// ✅ Withdraw
export const CashWithdrawRequest = createAsyncThunk(
  "wallet/CashWithdrawRequest",
  async (values) => {
    if (values.amount > 25000) {
      toast.error("Max Withdraw limit is 25000.", { theme: "colored" });
      return;
    }
    try {
      const response = await axiosBaseURL.post("/app/" + apiVersion.v1 + "/users/wallet/withdraw_request", values, {
        headers: authHeader()
      });
      return response.data;
    } catch (error) {
      HandleError(error.response.data);
      return error.response.data;
    }
  }
);


// PAN verification action
export const verifyPanAction = createAsyncThunk(
  "wallet/verifyPan",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosBaseURL.post(
        "/app/v1/users/verify_pan",
        formData,
        {
          headers: {
            ...authHeader(),
            "Content-Type": "multipart/form-data"
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);






// ✅ Refer & Earn
export const ReferEarnAsyncCall = createAsyncThunk(
  "wallet/ReferEarnAsyncCall",
  async () => {
    try {
      const response = await axiosBaseURL.get("/app/" + apiVersion.v1 + "/users/refer_earn_user", {
        headers: authHeader()
      });
      return response.data;
    } catch (error) {
      HandleError(error.response.data);
      return error.response.data;
    }
  }
);

// ✅ Initial State
const initialState = {
  transaction_history: {},
  ReferEarn: {},
  wallet: {},
  idcard_status: {},
  withdrawRequest: {},
  loading: false
};

// ✅ Slice
const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    ResetTranHistory: (state) => {
      state.transaction_history = {};
    },
    ResetWalletData: (state) => {
      state.wallet = {};
    },
    ResetReferEarnData: (state) => {
      state.ReferEarn = {};
    },
    ResetWithdrawRequest: (state) => {
      state.withdrawRequest = {};
    },
    ResetSureVerifyData: (state) => {
      state.idcard_status = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(WalletAsyncCall.pending, (state) => {
        state.loading = true;
      })
      .addCase(WalletAsyncCall.fulfilled, (state, { payload }) => {
        state.wallet = payload;
        state.loading = false;
      })
      .addCase(WalletAsyncCall.rejected, (state) => {
        state.loading = false;
      })

      .addCase(TransactionHistoryAsyncCall.pending, (state) => {
        state.loading = true;
      })
      .addCase(TransactionHistoryAsyncCall.fulfilled, (state, { payload }) => {
        state.transaction_history = payload;
        state.loading = false;
      })
      .addCase(TransactionHistoryAsyncCall.rejected, (state) => {
        state.loading = false;
      })

      .addCase(SureVerifyAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(SureVerifyAction.fulfilled, (state, { payload }) => {
  state.idcard_status = payload;
  state.loading = false;
  if (payload?.status) {
    toast.success(payload.message);  // ✅ Optional
  }
})


  .addCase(verifyPanAction.fulfilled, (state, { payload }) => {
      state.idcard_status = payload;
      state.loading = false;
      if (payload?.status) {
        toast.success(payload.message);
      }
    })
    .addCase(verifyPanAction.rejected, (state) => {
      state.loading = false;
    })




      .addCase(SureVerifyAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(CashWithdrawRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(CashWithdrawRequest.fulfilled, (state, { payload }) => {
        state.withdrawRequest = payload;
        state.loading = false;
      })
      .addCase(CashWithdrawRequest.rejected, (state) => {
        state.loading = false;
      })

      .addCase(ReferEarnAsyncCall.pending, (state) => {
        state.loading = true;
      })
      .addCase(ReferEarnAsyncCall.fulfilled, (state, { payload }) => {
        state.ReferEarn = payload;
        state.loading = false;
      })
      .addCase(ReferEarnAsyncCall.rejected, (state) => {
        state.loading = false;
      });
  }
});

// ✅ Export Actions
export const {
  ResetTranHistory,
  ResetWalletData,
  ResetReferEarnData,
  ResetWithdrawRequest,
  ResetSureVerifyData
} = walletSlice.actions;

// ✅ Export Selectors
export const getTranHistory = (state) => state.wallet.transaction_history;
export const getWalletData = (state) => state.wallet.wallet;
export const getReferEarnData = (state) => state.wallet.ReferEarn;
export const getWithdrawResponse = (state) => state.wallet.withdrawRequest;
export const getSureVerifyData = (state) => state.wallet.idcard_status;

// ✅ Export Reducer
export default walletSlice.reducer;
